import { FACE_SWAP_AND_MODEL_PAYLOAD } from "@/utils/toolsConstants";
import {create} from "zustand";

const useBatchAIStore = create((set) => ({
    batchAIType:"",
    totalJobCount:"",
    projectListLoading:false,
    projectList: [],
    loadingCanvas:false,
    applyingData:false,
    faceSwapAndModelPayload:{},
    selectedProjectGenerationImage:null,
    selectedProjectData:null,
    maualPrompt:null,
    manualPromptList:[],
    autoApplyReference:false,
    isModified:false,
    modifiedImageList:[],
    enableGeneration:false,
    referenceImageList:[], 
    instructionList:[],
    isConfirmModalOpen:false,
    applyingSave:false,
    generationType:"",
    isReferenceImageSelected:"",
    setIsReferenceImageSelected: (newData) => set({isReferenceImageSelected:newData}),
    setGenerationType: (newData) => set({generationType:newData}),
    setBatchAIType: (newData) => set({batchAIType:newData}),
    setTotalJobCount: (newData) => set({totalJobCount:newData}),
    setProjectListLoading: (newData) => set({projectListLoading:newData}),
    setProjectList: (newData) => set({ projectList: newData }),
    setLoadingCanvas: (newData) => set({loadingCanvas:newData}),
    setApplyingData: (newData) => set({applyingData:newData}),
    setSelectedProjectGenerationImage: (newData) => set({selectedProjectGenerationImage:newData}),
    setSelectedProjectData: (newData) => set({ selectedProjectData: newData }),
    setFaceSwapAndModelPayload: (newData) => set({ faceSwapAndModelPayload: newData }),
    setManualPrompt: (newData) => set({manualPrompt:newData}),
    setManualPromptList: (newData) => set({manualPromptList:newData}),
    setAutoApplyReference: (newData) => set({autoApplyReference:newData}),
    setIsModified: (newData) => set({isModified:newData}),
    setModifiedImageList: (newData) => set({modifiedImageList:newData}),
    setEnableGeneration: (newData) => set({enableGeneration:newData}),
    setReferenceImageList: (newData) => set({referenceImageList:newData}),
    setInstructionList: (newData) => set({instructionList:newData}),
    setIsConfirmModalOpen: (newData) => set({isConfirmModalOpen:newData}),
    setApplyingSave: (newData) => set({applyingSave:newData}),
    clearBulkAIStore: () => set((state) => ({
        batchAIType:"",
        totalJobCount:"",
        projectListLoading:false,
        projectList: [],
        loadingCanvas:false,
        applyingData:false,
        faceSwapAndModelPayload:{},
        selectedProjectGenerationImage:null,
        selectedProjectData:null,
        maualPrompt:null,
        manualPromptList:[],
        autoApplyReference:false,
        isModified:false,
        modifiedImageList:[],
        enableGeneration:false,
        instructionList:[],
        isConfirmModalOpen:false,
        applyingSave:false,
        generationType: state.generationType || "",
        isReferenceImageSelected:"",
    }))
}));

export default useBatchAIStore;
